import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantity", "totalPrice", "unitPrice", "hpp"]

  connect() {
    this.calculate()
  }

  calculate() {
    const quantity = parseFloat(this.quantityTarget.value) || 0
    const totalPrice = parseFloat(this.totalPriceTarget.value) || 0

    let hpp = 0
    if (quantity > 0 && totalPrice > 0) {
      hpp = totalPrice / quantity
    }

    // Update the hidden unit price field
    this.unitPriceTarget.value = hpp

    // Update the HPP display
    if (this.hasHppTarget) {
      if (hpp > 0) {
        this.hppTarget.textContent = `HPP: ${this.formatNumber(Math.round(hpp))}`
        this.hppTarget.classList.remove("hidden")
      } else {
        this.hppTarget.classList.add("hidden")
      }
    }
  }

  formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  }
}
